export function menu() {
    return {
        open: window.innerWidth >= 1280,
        openFilters: window.innerWidth >= 1280,

        init() {
            this.open = window.innerWidth >= 1280;
            this.openFilters = window.innerWidth >= 1280;

            window.addEventListener('resize', () => {
                this.open = window.innerWidth >= 1280;
                this.openFilters = window.innerWidth >= 1280;
            });
        }
    };
}

export function videoPlayer() {
    return {
        playing: false,

        play() {
            this.$refs.video.play();
            this.$refs.video.controls = true;
            this.playing = true;
        },

        onEnded() {
            this.$refs.video.controls = false;
            this.playing = false;
        }
    };
}

export function ageGate() {
    return {
        show: false,
        showError: false,
        closing: false,
        fading: false,

        init() {
            const verified = localStorage.getItem('ageVerified');
            this.show = verified !== 'true';

            if (this.show) {
                document.body.style.overflow = 'hidden';
            }
        },

        confirm() {
            localStorage.setItem('ageVerified', 'true');
            const hasKeys = this.$root.querySelectorAll('[data-key]').length > 0;
            if (hasKeys) {
                this.closing = true;
                setTimeout(() => {
                    this.fading = true;
                    setTimeout(() => {
                        this.show = false;
                        this.closing = false;
                        this.fading = false;
                        document.body.style.overflow = '';
                    }, 500);
                }, 1000);
            } else {
                this.show = false;
                document.body.style.overflow = '';
            }
        },

        deny() {
            this.showError = true;
        }
    };
}

export function instagramFeed(accessToken) {
    return {
        images: [],
        loading: true,
        error: null,

        async init() {
            if (!accessToken) {
                this.loading = false;
                return;
            }
            await this.fetchImages();
        },

        async fetchImages() {
            try {
                const response = await fetch(
                    `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url&access_token=${accessToken}`
                );

                if (!response.ok) throw new Error('Failed to fetch Instagram feed');

                const data = await response.json();
                this.images = data.data
                    .filter(item => item.media_type === 'IMAGE' || item.media_type === 'CAROUSEL_ALBUM')
                    .slice(0, 12)
                    .map(item => ({
                        url: item.media_url,
                        permalink: item.permalink,
                        alt: item.caption || 'Instagram post'
                    }));

                this.loading = false;

                // Reinitialize swiper after images load
                this.$nextTick(() => {
                    window.dispatchEvent(new CustomEvent('instagram-loaded'));
                });
            } catch (err) {
                this.error = err.message;
                this.loading = false;
            }
        }
    };
}
